export default {
  "article.related": "相关推荐",
  "article.share": "分享",
  "article.views": "次观看",
  "article.publishDate": "发布时间",
  "article.category": "分类",
  "article.tags": "标签",
  "article.backToList": "返回列表",
  "article.previous": "上一篇",
  "article.next": "下一篇",
  "article.author": "作者",
};